import { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { AXIOS_INSTANCE } from "../../api/client";
import { getAuth } from "firebase/auth";

export type TGetCommonMemberIconRespone = {
  status_code: number;
  data: any;
};

export const getCommonMemberIcon = async (): Promise<TGetCommonMemberIconRespone> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const request = {
    url: `/images/common/member-icon`,
    method: "get",
    headers: { "Content-Type": "application/json" , Authorization: `Bearer ${token}`} as AxiosRequestHeaders,
  };
  return AXIOS_INSTANCE(request as AxiosRequestConfig<any>).then(
    ({ data }) => data
  );
};
